// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { paymentMethodStyles } from "@west/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPaymentMethod";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

paymentMethodStyles.container = {
    css: css`
        padding-top: 24px;
        border-top: 1px solid ${color("common.border")};
        display: flex;
        flex-wrap: wrap;
        gap: 24px;
        & > div {
            flex: 1;
        }

        ${xScreen("lt", "sm")} {
            flex-direction: column;
            & > div {
                flex: initial;
            }
        }
    `,
};

paymentMethodStyles.paymentTitle = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
        width: 100%;
    `,
};

paymentMethodStyles.paymentMethodTitleText = {
    variant: "h5",
    css: css`
        margin-bottom: 8px;
    `,
};

paymentMethodStyles.purchaseOrderTitleText = {
    variant: "h5",
    css: css`
        margin-bottom: 8px;
    `,
};

paymentMethodStyles.paymentMethodText = {
    size: 14,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        margin-bottom: 0;
        white-space: pre;
    `,
};

paymentMethodStyles.purchaseOrderText = {
    size: 14,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        margin-bottom: 0;
    `,
};
